import { Alert, Button, Calendar, FormField, Link, Modal, Select, SelectProps, Table, TextFilter, TimeInput } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import React, { useEffect, useRef, useState } from 'react';

import {
    addNotification,
    addNotificationStatus,
    buildBreadcrumbItems, getCookie, getToday, getUrlVersion, getUser,
    setData,
    setLoading,
    setParameters,
    setRUT
} from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
import { useRouter } from '../../../../router';
import { useStore } from '../../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { formatRut, validateRut } from '@fdograph/rut-utilities';
import { format, parse } from 'date-fns';
import DRPicker from '../../../../../../components/DRPicker';
import BadgeCustom from '../../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../../components/extras/SidePanelMovement';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../../resources/types';

const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const OPSFlightsVouchersListPage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    //const storeAdmin = useStoreAdmin();
    const voucherStages = [
        { label: 'Todos', value: "-2" },
        { label: 'No programado', value: "0" },
        { label: 'En venta', value: "1" },
        { label: 'Adjudicado', value: "2" },
        { label: 'Realizado', value: "3" },
        { label: 'Anulado', value: "-1" },
    ]
    const [programTime, setProgramTime] = useState("");
    const [programDate, setProgramDate] = useState("");
    const [voucherStage, setVoucherStage] = useState(-2);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [movement, setMovement] = useState<ItemsMovement>();
    const [movementSell, setMovementSell] = useState<ItemsMovement>();
    const [movementProgram, setMovementProgram] = useState<ItemsMovement>();
    const [movements, setMovements] = useState<ItemsMovement[]>([]);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    const [detailPanel, setDetailPanel] = useState(false);

    useEffect(() => {
        handleGetVouchers();
    }, [parameters.startDate, parameters.endDate, voucherStage]);

    const handleFetchAndDownload = async () => {
        setLoading(true);
        const targetUrl = `https://${getUrlVersion()}/resources/vouchers/generate.aspx?hashMovement=357701082E37A9-7FAF-440E-B35A-4461C30C0D92`; // The URL you want to capture

        // Using a public CORS proxy for demonstration
        const proxyUrl = `https://cors-anywhere.herokuapp.com/${targetUrl}`;

        try {
            // 1. Fetch the raw HTML string
            const response = await fetch(targetUrl);
            const htmlString = await response.text();

            // 2. Inject the HTML into our hidden container
            if (hiddenContainerRef.current) {
                let cleanHtml = htmlString.replace(/display:\s*block\s*;?/gi, '');
                hiddenContainerRef.current.innerHTML = cleanHtml;
            }

            // 3. Wait a brief moment for images/styles to parse
            setTimeout(async () => {
                const element = hiddenContainerRef.current;

                // 4. Convert to Canvas and PDF
                const canvas = await html2canvas(element, {
                    scale: 2, useCORS: true,
                    // Ensures the "Club de Planeadores" logo loads
                    width: 800,             // Matches your CSS container width exactly
                    windowWidth: 800,       // Forces the virtual browser viewport to be 800px
                    logging: false          // Keeps console clean

                });
                const imgData = canvas.toDataURL('image/png');

                //console.log(canvas.width, canvas.height)
                const imgWidth = 210;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'mm',
                    format: [imgWidth, imgHeight] // Pass custom dimensions here
                });
                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                pdf.save('url-captured.pdf');

                // 5. Clean up the container
                hiddenContainerRef.current.innerHTML = '';
                setLoading(false);
            }, 1000);

        } catch (error) {
            console.error("Error fetching URL:", error);
            setLoading(false);
        }
    };
    const handleProgramSell = async () => {
        //
        try {
            setLoading(true)
            movementSell.jsonMovement.dateStartSell = format(new Date(), 'yyyy-MM-dd HH:mm');;
            movementSell.jsonMovement.stage = 2;
            movementSell.voucherStage = 1;
            //return
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(movementSell),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setMovementSell(undefined)
                handleGetVouchers();
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const handleProgramDate = async () => {
        //if (parameters.startDate && parameters.endDate) {
        setDetailPanel(false);
        if (programDate && programTime && movementProgram) {
            //
            try {
                setLoading(true)
                let newDate = format(parse(`${programDate} ${programTime}`, 'yyyy-MM-dd HH:mm', new Date()), 'dd-MM-yyyy HH:mm');
                movementProgram.jsonMovement.dateProgram = newDate;
                movementProgram.jsonMovement.stage = 1;
                //return
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/update',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(movementProgram),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovementProgram(undefined)
                    handleGetVouchers();
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    const handleGetVouchers = async () => {
        //if (parameters.startDate && parameters.endDate) {
        setDetailPanel(false);
        if (parameters.startDate && parameters.endDate) {
            //
            try {
                setLoading(true)
                const body: any = {
                    ...(voucherStage !== -2 && { voucherStage }),

                    dateStart: parameters.startDate,
                    dateEnd: parameters.endDate,
                    idAccountPlan: 83024,
                    isPax: true,
                    orderBy: "dateTransaction",
                    order: "desc",
                    orderBy2: "idMovement",
                    order2: "desc",
                    columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, voucherStage, idFlight, hashMovement, obs"
                    // other properties here...
                };
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(body),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovements(data.movements);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    const handleRUTBlur = () => {
        if (validateRut(RUT)) {
            setRUT(formatRut(RUT))
        }
    }
    const filtered: ItemsMovement[] = movements.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.data, item.RUT, item.ammount, item.idMovement.toString(), item.receipt.toString(), item?.jsonMovement?.nombre, item?.jsonMovement?.email, item?.jsonMovement?.movil, item?.jsonMovement?.rut].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);
    const tableRef = useRef(null);
    const hiddenContainerRef = useRef(null);
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={detailPanel}
            onSplitPanelToggle={({ detail }) => setDetailPanel(detail.open)}
            splitPanel={
                <SidePanelMovement movement={movement ?? {}} />
            }
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Button onClick={handleFetchAndDownload} disabled={loading}>
                        {loading ? 'Processing...' : 'Grab URL & Download PDF'}
                    </Button>
                    <div
                        ref={hiddenContainerRef}
                        style={{
                            position: 'absolute',
                            left: '-9999px',
                            top: '0',
                            width: '800px', // Standardized width for the PDF layout
                            backgroundColor: '#ffffff'
                        }}
                    />
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Vouchers generados
                        </Header>


                        {parameters.startDate !== '' && parameters.endDate !== '' && (

                            <SpaceBetween direction='vertical' size='xs'>

                                <Table ref={tableRef}
                                    variant="embedded"
                                    //onRowClick={({ detail }) => { setMovement(detail.item); setDetailPanel(true); //console.log(detail.item.jsonDocuments) }}
                                    stickyHeader
                                    filter={

                                        <SpaceBetween direction="horizontal" size="xs">

                                            <DRPicker start={parameters.startDate} end={parameters.endDate}
                                                onConfirm={(startDate: string, endDate: string) => {
                                                    const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                                    setParameters(updatedParameters);
                                                }}
                                            />
                                            <Select
                                                selectedOption={voucherStages.find(option => Number(option.value) === voucherStage) || null}
                                                onChange={({ detail }) =>
                                                    setVoucherStage(Number(detail.selectedOption.value))
                                                }
                                                options={voucherStages}
                                            />
                                            <TextFilter filteringText={filterValue} onChange={({ detail }) => setFilterValue(detail.filteringText)} />
                                        </SpaceBetween>
                                    }
                                    pagination={
                                        filtered.length > pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(filtered.length / pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )
                                    }
                                    columnDefinitions={[
                                        {
                                            id: "dateTransaction",
                                            header: "Fecha",
                                            cell: item => (

                                                <FormField
                                                    label={<Link onClick={() => { setMovement(item); setDetailPanel(true) }}>{item.idMovement}</Link>}
                                                    description={item.dateTransaction}
                                                />
                                            ),
                                            width: 120
                                        },
                                        {
                                            id: "number",
                                            header: "Folio",
                                            cell: item => item.receipt,
                                            width: 120
                                        },
                                        {
                                            id: "idUser",
                                            header: "PAX",
                                            cell: item => (

                                                <FormField
                                                    label={item.jsonMovement.nombre}
                                                    description={item.jsonMovement.rut}
                                                />
                                            )
                                        },
                                        {
                                            id: "data",
                                            header: "Status",
                                            cell: item => (

                                                <BadgeCustom bold={false} size='medium' color={(item?.idFlight ?? 0) > 0 ? "blue" : item.voucherStage === 0 ? "light" : item.voucherStage === -1 ? "red" : item.voucherStage === 1 ? "blue" : item.voucherStage === 2 ? "green" : item.voucherStage === 3 ? "violet" : "dark"}>
                                                    {(item?.idFlight ?? 0) > 0 ? "Realizado" : item.voucherStage === 0 ? "No iniciado" : item.voucherStage === -1 ? "Anulado" : item.voucherStage === 1 ? "En venta" : item.voucherStage === 2 ? "Vendido" : item.voucherStage === 3 ? "Remate" : "Desconocido"}{" ["}{item.voucherStage}{"]"}</BadgeCustom>
                                            )
                                        },
                                        {
                                            id: "charge",
                                            header: "Programa",
                                            cell: item => (
                                                <>
                                                    {item.jsonMovement?.dateProgram !== "" && (
                                                        <SpaceBetween direction='horizontal' size='xs'>
                                                            <FormField
                                                                label={item.jsonMovement?.dateProgram}
                                                            >
                                                                {item.jsonMovement?.idUser === 0 && item.jsonMovement.dateStartSell !== "" && (
                                                                    <>No adjudicado aun</>
                                                                )}
                                                                {item.jsonMovement?.idUser > 0 && (
                                                                    getUser(item.jsonMovement?.idUser, data)?.displayName
                                                                )}

                                                            </FormField>
                                                            {item.jsonMovement?.dateStartSell === "" && (

                                                                <Button onClick={() => { setMovementSell(item); }}>Vender</Button>


                                                            )}
                                                        </SpaceBetween>
                                                    )}

                                                    {item.jsonMovement?.dateProgram === "" && (
                                                        <Button onClick={() => { setMovementProgram(item); setProgramDate(""); setProgramTime(""); }}>Programar</Button>
                                                    )}
                                                </>
                                            )


                                        },
                                    ]}
                                    trackBy="idMovement"
                                    items={paginated ?? []}
                                    empty={
                                        <Box
                                            margin={{ vertical: "xs" }}
                                            textAlign="center"
                                            color="inherit"
                                        >
                                            <SpaceBetween size="m">
                                                <b>Sin vouchers asociados</b>
                                            </SpaceBetween>
                                        </Box>
                                    }
                                />
                            </SpaceBetween>

                        )}

                        <Modal size="small" visible={!!movementProgram} onDismiss={() => setMovementProgram(undefined)} closeAriaLabel="Close modal" header="Fecha de programa" footer={
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                }}
                            >
                                <Button variant="link" onClick={() => setMovementProgram(undefined)}>Cancelar</Button>
                                <Button variant="primary" disabled={!programDate || !programTime || programTime.length !== 5} onClick={() => handleProgramDate()}>Confirmar</Button>
                            </div>
                        }>
                            <SpaceBetween direction="vertical" size="s">
                                <Calendar
                                    isDateEnabled={date => {
                                        return date.getTime() >= getToday();
                                    }}

                                    onChange={({ detail }) => {
                                        setProgramDate(detail.value);
                                        //setMovement((prev) => ({ ...prev, jsonMovement: { ...prev?.jsonMovement, dateProgram: detail.value } } as ItemsMovement))
                                    }}

                                    value={programDate}
                                    locale="es_CL"
                                    startOfWeek={1}
                                />
                                <FormField label="Hora">
                                    <TimeInput format="hh:mm" value={programTime} onChange={({ detail }) => setProgramTime(detail.value)}  ></TimeInput>
                                </FormField>

                                <Alert type="info">
                                    {!(!programDate || !programTime || programTime.length !== 5) ?
                                        <>
                                            El PAX se programará para el <strong>{programDate}</strong> a las <strong>{programTime}</strong> hrs. </> : null}

                                    El voucher será puesto a la venta</Alert>
                            </SpaceBetween>


                        </Modal>

                        <ConfirmDelete header='Poner a la venta' action='Vender' confirmWord='vender'
                            onConfirm={() => {
                                handleProgramSell()
                            }}
                            onDismiss={() => setMovementSell(undefined)}
                            show={!!movementSell} warning={'Una vez puesto a la venta el PAX, el grupo mercenarios será notificado'}
                        />
                    </SpaceBetween>


                </>
            }
        />
    );
};
